import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IWellWaterSystem } from '../../types';
import { fetchWellWaterSystemsAsync, fetchWellWaterSystemsAsyncBuilder } from './asyncRequests';

export interface IPagination {
  page: number;
  limit: number;
  totalPages: number;
}

export interface IWellWaterSystemsData{
  pagination: IPagination;
  totalWells: number;
  wellWaterSystems: IWellWaterSystem[]
}

export interface WellWaterSystemsInitialState {
  data: IWellWaterSystemsData
  loading: boolean;
  error: string;
  success: boolean;
  userSearched: boolean
  selectedWellWaterSystem: any
}

const initialState: WellWaterSystemsInitialState = {
  data: {} as IWellWaterSystemsData,
  loading: false,
  error: '',
  success: false,
  userSearched: false,
  selectedWellWaterSystem: null
};

export const WellWaterSystemsSlice = createSlice({
  name: 'wellWaterSystemsSlice',
  initialState,
  reducers: {
    setUserSearched: (state, action) => {
      state.userSearched = action.payload;
    },
    setSelectedWellWaterSystem: (state, action: PayloadAction<string | null>) => {
      state.selectedWellWaterSystem = action.payload;
    },
    resetWaterSystemsData: (state) => {
      state.data = initialState.data
    },
  },
  extraReducers: (builder) => {
    fetchWellWaterSystemsAsyncBuilder(builder);
  },
});

export const WellWaterSystemsActions = {
  ...WellWaterSystemsSlice.actions,
  fetchWellWaterSystemsAsync,
};

export const WellWaterSystemsReducer = WellWaterSystemsSlice.reducer;